(() => {
  "use strict";

  const root = document.getElementById("email-marketing-confirm-root");
  if (!root) return;

  const button = document.getElementById("email-marketing-confirm-button");
  const status = document.getElementById("email-marketing-confirm-status");
  const rawFragment = String(window.location.hash || "").replace(/^#/, "");
  const fragment = new URLSearchParams(rawFragment);
  const token = String(fragment.get("token") || "").trim();

  // Remove the bearer token before the user interacts with the page. This
  // keeps it out of copied URLs, browser history entries, and referrers.
  if (window.location.hash) {
    window.history.replaceState(null, document.title, `${window.location.pathname}${window.location.search}`);
  }

  function showStatus(message, success) {
    status.textContent = String(message || "");
    status.classList.remove("d-none", "alert-success", "alert-danger");
    status.classList.add(success ? "alert-success" : "alert-danger");
  }

  async function getCsrfToken() {
    const existing = String(window.frappe?.csrf_token || "").trim();
    if (existing && existing !== "None") return existing;

    const response = await fetch("/api/method/zoni_edu.services.csrf_bootstrap", {
      method: "POST",
      credentials: "include",
      headers: { Accept: "application/json" },
    });
    const data = await response.json();
    const csrfToken = String(data?.message?.csrf_token || "").trim();
    window.frappe.csrf_token = csrfToken;
    return csrfToken;
  }

  async function confirmConsent() {
    if (!token) {
      showStatus(root.dataset.missingTokenMessage, false);
      button.disabled = true;
      return;
    }

    button.disabled = true;
    const originalLabel = button.textContent;
    button.textContent = root.dataset.confirmingLabel;

    try {
      const csrfToken = await getCsrfToken();
      const response = await fetch(
        "/api/method/zoni_edu.zoni_edu.email_marketing_consent.confirm_email_marketing_opt_in",
        {
          method: "POST",
          credentials: "include",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Frappe-CSRF-Token": csrfToken,
          },
          body: JSON.stringify({ token }),
        }
      );
      const payload = await response.json();
      const result = payload?.message || {};
      if (!response.ok) throw new Error("confirmation_request_failed");

      showStatus(result.message || root.dataset.networkErrorMessage, Boolean(result.ok));
      if (!result.ok) button.disabled = false;
    } catch (_) {
      showStatus(root.dataset.networkErrorMessage, false);
      button.disabled = false;
    } finally {
      button.textContent = originalLabel;
    }
  }

  if (!token) {
    showStatus(root.dataset.missingTokenMessage, false);
    button.disabled = true;
  } else {
    button.addEventListener("click", confirmConsent);
  }
})();
